<template>
  <div class="text-xs-center" style="text-align:left !important">
    
	<!-- <v-btn @click="type='nodejs'; typeSelected='nodejs'">NodeJs</v-btn>    	
	<v-btn @click="type='scatter'; typeSelected='scatter'">Scatter</v-btn> -->
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Download Smartpress config
        </v-card-title>

        <v-layout>
	        <v-flex style="padding:20px">
	          <span v-if="!configDownloaded">
			        <v-btn  @click="downloadConfig()" outline large fab color="indigo">
					      <v-icon>cloud_download</v-icon>
					    </v-btn>
					    <span class="subheading">Click here to download config</span>
					  </span>
	          <span v-if="configDownloaded">	
					    <v-btn disabled outline small fab color="indigo">
					      <v-icon>cloud_done</v-icon>
					    </v-btn>
              <h2>Next</h2><br/><br/>
              <ol style="text-align:center;">
                <li>
                  <a href="/docs"  target="_blank"><span class="subheading" >Read Smartpress documentation</span></a><br/>
                </li>
                
                  <span style="text-align:center;display:block;margin-top:20px;">and</span><br/>
                
                <li>
                  <a href="/myUsers"  target="_blank"><span class="subheading" >Visit the 'My users' page</span></a>
                </li>

                  <span style="text-align:center;display:block;margin-top:20px;">or</span><br/>

                <li>
                  <span class="subheading"><a target="_blank" href="https://www.youtube.com/embed/6kK6xj47jNs">Watch our explainer video</a></span>
                </li>
                
              </ol>
              <br/>
              
					  </span>
				    
	    		</v-flex>
	    	</v-layout>
      </v-card>
 
  </div>
</template>

<script>
  import { mapState } from 'vuex'
 
  export default {
  	mounted: function  () {
  		console.log(this.open)
  		this.$store.dispatch('contractsDb/getApiKey')
  	},
    data () {
      return {
        e1: 0,
        dialog: true,
        typeSelected: 'scatter',
        type: '',
        configDownloaded: false
      }
    },
    props: { open: Boolean },
    computed: {
    	dialogOpen: function () {
    	 	console.log(this.open)
	    	return this.open
	    },
      ...mapState({
          myContracts: state => state.contractsDb.myContracts,
          myApiKey: state => state.contractsDb.myApiKey,
      }),
    },
    methods: {
    	closeDialog: function () {
    		 
    			this.$emit('connectClosed', false)
  
    		
    	},
    	downloadConfig: function () {
    		console.log('running')

let exportObj = `// WARNING: DO NOT EDIT. Version: 0.0.1 | This file is Auto-Generated by Smartpress. It will be overwritten. ` + '\n' +
`const config = { ` + '\n' + `
	'API_KEY':` + '"' + this.myApiKey.Items[0].api_key.S + '",' + '\n' + `
	'user_id':` + '"' + this.myContracts.Items[0].user_id.S + '"' + '\n' + `
}` + '\n' + `
module.exports = config`;

    // 		var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
				// var dlAnchorElem = document.getElementById('downloadAnchorElem');
				// dlAnchorElem.setAttribute("href",     dataStr     );
				// dlAnchorElem.setAttribute("download", "scene.json");
				// dlAnchorElem.click();

			

		    var dataStr = "data:text/javascript;charset=utf-8," + encodeURIComponent(exportObj);
		    var downloadAnchorNode = document.createElement('a');
		    downloadAnchorNode.setAttribute("href",     dataStr);
		    downloadAnchorNode.setAttribute("download", "smartpressConfig.js");
		    document.body.appendChild(downloadAnchorNode); // required for firefox
		    downloadAnchorNode.click();
		    downloadAnchorNode.remove();


		    this.configDownloaded = true
		    console.log('finished')
    	}
    }
  }
</script>


<style scoped>

  /**
 * prism.js Funky theme
 * Based on “Polyfilling the gaps” talk slides http://lea.verou.me/polyfilling-the-gaps/
 * @author Lea Verou
 */

code[class*="language-"],
pre[class*="language-"] {
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  font-size:20px;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  background-color:black !important;

  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;

  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

/* Code blocks */
pre[class*="language-"] {
  padding: .4em .8em;
  margin: .5em 0;
  overflow: auto;
  background: url('data:image/svg+xml;charset=utf-8,<svg%20version%3D"1.1"%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"100"%20height%3D"100"%20fill%3D"rgba(0%2C0%2C0%2C.2)">%0D%0A<polygon%20points%3D"0%2C50%2050%2C0%200%2C0"%20%2F>%0D%0A<polygon%20points%3D"0%2C100%2050%2C100%20100%2C50%20100%2C0"%20%2F>%0D%0A<%2Fsvg>');
  background-size: 1em 1em;
}

code[class*="language-"] {
  background: black;
  color: white;
  box-shadow: -.3em 0 0 .3em black, .3em 0 0 .3em black;
}

/* Inline code */
:not(pre) > code[class*="language-"] {
  padding: .2em;
  border-radius: .3em;
  box-shadow: none;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #aaa;
}

.token.punctuation {
  color: #999;
}

.namespace {
  opacity: .7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol {
  color: #0cf;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin {
  color: yellow;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.toke.variable,
.token.inserted {
  color: yellowgreen;
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: deeppink;
}

.token.regex,
.token.important {
  color: orange;
}

.token.important,
.token.bold {
  font-weight: bold;
}
.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

.token.deleted {
  color: red;
}


</style>